import(/* webpackMode: "eager", webpackExports: ["BalanceWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
